module.exports = __webpack_public_path__ + "img/attention.effb3f2b.png";